var React = require('react');

function LongArrow (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_22_5146)","key":0},[React.createElement("path",{"d":"M0.5 7H92.5","stroke":"currentColor","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M84 0L93 7","stroke":"currentColor","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M84 14L93 7","stroke":"currentColor","strokeLinecap":"round","key":2})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_22_5146"},React.createElement("rect",{"width":"92.5","height":"14","fill":"white","transform":"translate(0.5)"})))]);
}

LongArrow.defaultProps = {"width":"93","height":"14","viewBox":"0 0 93 14","fill":"none"};

module.exports = LongArrow;

LongArrow.default = LongArrow;
